__turbopack_context__.v({
  "className": "caveat_f4decfa8-module__lD6-Za__className",
});
